(function () {
    'use strict';

    angular.module("imApp").factory("timeRegisterSplitService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1860,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1861,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
